module.exports = __webpack_public_path__ + "static/media/avatar_31.bf2a01c5.svg";